import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';  // Import CommonModule

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss'
})
export class SplashScreenComponent {
  // isVisible: boolean = false;

  // constructor(private router: Router) { }

  // ngOnInit(): void {
  //   // Trigger the animation after a slight delay
  //   setTimeout(() => {
  //     this.isVisible = true;
  //   }, 100); // Short delay to allow for the component rendering

  //   // Hide the splash screen after 5 seconds and navigate to another page
  //   setTimeout(() => {
  //     this.isVisible = false;
  //     // Navigate to another page (e.g., home page) after splash screen
  //     // this.router.navigate(['/authentication/login']); // Adjust '/home' to your target route
  //   }, 5000); // Hide splash screen after 5 seconds
  // }

  isVisible: boolean = false;
  isRotated: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.isVisible = true;  // Bring images to the center
    }, 100);

    setTimeout(() => {
      this.isRotated = true;  // Trigger the rotation and zoom effect on image1
    }, 2500);  // After 2.5 seconds, start rotation and zoom-out animation

    setTimeout(() => {
      // this.isVisible = false; // Hide the splash screen after 5 seconds
      this.router.navigate(['authentication/login']); // Navigate to home or other route
    }, 5000);
  }
}
